module.exports = __webpack_public_path__ + "img/ic-map-tile-all.e30b7841.svg";